// core
import React from "react";
import { useLocation } from "react-router-dom";

// hooks
import useThemeMode from "Utils/useThemeMode";

// services
import { environment } from "Config/config";

// components
import BreakGlassLoginForm from "Components/Login/BreakGlassLoginForm";
import ConsumerLoginForm from "Components/Login/ConsumerLoginForm";
import ForgotLoginForm from "Components/Login/ForgotLoginForm";
import LoginForm from "Components/Login/LoginForm";
import MagicLinkCheck from "Components/Login/MagicLinkCheck";
import MagicLinkForm from "Components/Login/MagicLinkForm";
import MfaLoginForm from "Components/Login/MfaLoginForm";
import ResetPasswordForm from "Components/Login/ResetPasswordForm";

// styles
import styles from "./LoginPage.module.css";

// main component
function LoginPage({ formType }) {
    // injections
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    // Keeps the theme-light / theme-dark class on <html> in sync (including
    // changes made in other tabs). All themed values are CSS variables now, so
    // there is nothing else to thread through the tree — the MUI ThemeProvider
    // and CssBaseline this used to render are gone with Utils/LoginTheme.js.
    useThemeMode();

    // calculated
    let token = "";
    let magicLink = "";

    if (formType === "reset") {
        token = searchParams.get("token");
    } else if (formType === "magicLink") {
        magicLink = searchParams.get("magicLink");
    }

    // render
    return (
        <div
            className={styles.page}
            onSubmitCapture={(e) => {
                e.preventDefault();
            }}
        >
            {formType === "breakGlass" ? (
                <BreakGlassLoginForm />
            ) : formType === "consumerLogin" ? (
                <ConsumerLoginForm />
            ) : formType === "mfa" ? (
                <MfaLoginForm />
            ) : formType === "forgot" ? (
                <ForgotLoginForm />
            ) : formType === "reset" && token ? (
                <ResetPasswordForm token={token} />
            ) : formType === "magicLink" &&
              magicLink &&
              environment === "trial" ? (
                <MagicLinkCheck magicLink={magicLink} />
            ) : environment === "trial" ? (
                <MagicLinkForm />
            ) : (
                <LoginForm />
            )}
        </div>
    );
}

export default LoginPage;
